import moment from "moment";

const fromNow = (now) => {
  // return moment.unix(now).fromNow();
  return moment.unix(now).format("YYYY-MM-DD HH:mm");
};

const timeDiff = (prev, now) => {
  let n = moment.unix(now);
  let p = moment.unix(prev);

  let ms = n.diff(p);
  let d = moment.duration(ms);

  return d.asSeconds();
};

const substring = (str, size = 6) => {
  if (!str) return;
  if (str === "contract") return str;

  let f = str.slice(0, size);
  let b = str.slice(str.length - size);

  let rest = f + "..." + b;
  return rest;
};

const timeNow = () => {
  return moment.utc().format();
};

const isJoinTx = (addr) => {
  if (addr === "0x5AeaB10a26Ce20fE8f463682FfC3Cf72D2580c3c") {
    return "JoinTx";
  } else if (addr === null || addr === "") {
    return "Contract";
  } else {
    return "Transfer";
  }
};

const pageMove = (cur, total, div, self, callback) => {
  if (div === "prv") {
    if (cur > 1) {
      self.setState(
        {
          currentPage: cur - 1,
        },
        () => {
          callback();
        }
      );
    }
  } else if (div === "next") {
    if (cur < total) {
      self.setState(
        {
          currentPage: cur + 1,
        },
        () => {
          callback();
        }
      );
    }
  }
};

const wei2Daon = (wei) => {
  let num = wei * 0.000000000000000001;
  return num.toFixed(5).replace(/\.?0+$/, "");
};

const wei2Gwei = (wei) => {
  let num = wei * 0.000000001;
  return num.toFixed(5).replace(/\.?0+$/, "");
};

const wei2DaonDecimal = (wei, dec) => {
  let num = wei * 0.000000000000000001;
  return num.toFixed(dec).replace(/\.?0+$/, "");
};

const wei2CustomValue = (wei, val, dec) => {
  let num = wei * Math.pow(10, val);
  return num.toFixed(dec).replace(/\.?0+$/, "");
};

const getValueByDecimals = (wei, decimals) => {
  return wei * Math.pow(10, -decimals);
};

const toFixed = (x) => {
  if (Math.abs(x) < 1.0) {
    var e = parseInt(x.toString().split("e-")[1]);
    if (e) {
      x *= Math.pow(10, e - 1);
      x = "0." + new Array(e).join("0") + x.toString().substring(2, 4);
    }
  } else {
    var e = parseInt(x.toString().split("+")[1]);
    if (e > 20) {
      e -= 20;
      x /= Math.pow(10, e);
      x += new Array(e + 1).join("0");
    }
  }
  return x;
};

/**
 * @return {string}
 */
function getNetWork() {
  let chainID = process.env.REACT_APP_CHAIN_ID;
  if (chainID === "14288641") {
    return "testnet";
  } else if (chainID === "14288640") {
    return "mainnet";
  } else {
    return `unknown_${chainID}`;
  }
}

function arc721abiReplace(abi) {
  switch (abi) {
    case "095ea7b3":
      return "approve";
    case "70a08231":
      return "balanceOf";
    case "42966c68":
      return "burn";
    case "081812fc":
      return "getApproved";
    case "e985e9c5":
      return "isApprovedForAll";
    case "8fc93653":
      return "name";
    case "1caa4f65":
      return "owner";
    case "6352211e":
      return "ownerOf";
    case "f418d78a":
      return "renounceOwnership";
    case "d204c45e":
      return "safeMint";
    case ("b88d4fde", "42842e0e"):
      return "safeTransferFrom";
    case "a22cb465":
      return "setApprovalFroAll";
    case "01ffc9a7":
      return "supportsInerface";
    case "7ec9608":
      return "symbol";
    case "4f6ccce7":
      return "tokenByIndex";
    case "2f745c59":
      return "tokenOfOwnerByIndex";
    case "c87b56dd":
      return "tokenURI";
    case "247f0ca7":
      return "totalSupply";
    case "23b872dd":
      return "transferFrom";
    case "f2fde38b":
      return "transferOwnership";
  }
}

export {
  fromNow,
  timeDiff,
  substring,
  timeNow,
  isJoinTx,
  pageMove,
  wei2Daon,
  wei2Gwei,
  wei2DaonDecimal,
  wei2CustomValue,
  getValueByDecimals,
  getNetWork,
  toFixed,
  arc721abiReplace,
};
